import { ExpandMoreRounded, GitHub, Shop } from '@mui/icons-material'
import { Box, Button, Card, CardActions, CardContent, CardMedia, Chip, Collapse, IconButton, IconButtonProps, ImageList, ImageListItem, styled, Typography } from '@mui/material'
import React from 'react'
import { maxScreenshots } from '../../../config/const'
import { AppData } from '../../../Data/Models/AppData'


const StyledIcon = styled("img")(({ theme }) => ({
    height: "64px",
    width: "64px",
    borderRadius: theme.shape.borderRadius
}))

const Icons = styled(Box)(({ theme }) => ({
    display: "flex", gap: "5px", alignItems: "center"
}))

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const ProjectCard = (props: {
    appData: AppData,
    readMoreClick: () => void,
    editClick: (() => void) | null,
    deleteClick: (() => void) | null,
    screenshotsClick: (index: number) => void
}) => {

    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    var data: AppData = props.appData
    let editView: JSX.Element
    let deleteView: JSX.Element
    let gitHubUrl: JSX.Element = <></>
    let playStoreUrl: JSX.Element = <></>
    let listTags: JSX.Element = <></>

    if (props.editClick != null) {
        editView = (
            <Box sx={{ width: "100%" }} textAlign="end">
                <Button onClick={props.editClick}><Chip label="Edit" /></Button>
            </Box>
        )
    } else {
        editView = (<></>)
    }

    if (props.deleteClick != null) {
        deleteView = (
            <Box sx={{ width: "100%" }} textAlign="end">
                <Button onClick={props.deleteClick}><Chip label="Delete" /></Button>
            </Box>
        )
    } else {
        deleteView = (<></>)
    }

    if (props.appData.gitUrl) {
        gitHubUrl = (<IconButton aria-label="github" onClick={(e) => {
            window.open(props.appData.gitUrl, '_blank', 'noreferrer')
        }}>
            <GitHub color='secondary' />
        </IconButton>)
    }

    if (props.appData.playStoreUrl) {
        playStoreUrl = (<IconButton aria-label="playstore" onClick={(e) => {
            window.open(props.appData.playStoreUrl, '_blank', 'noreferrer')
        }}>
            <Shop color='secondary' />
        </IconButton>)
    }

    if (props.appData.tags.length > 0) {
        listTags = (<>
            {props.appData.tags.map((e) => {
                return (<span onClick={(event)=>{
                    window.open(`https://www.google.com/search?q=${e}`, '_blank', 'noreferrer')
                }}><Chip variant="outlined" color="secondary" size="small" label={e} sx={{ padding: '5px', margin: '5px' }} /></span>)
            })}

        </>)
    }

    return (
        <Card sx={{ margin: "10px" }}>
            <CardMedia
                component="img"
                height="140"
                image={data.featureImageUrl}
                alt="green iguana"
                onClick={handleExpandClick}
            />

            <CardContent onClick={handleExpandClick}>
                <Box sx={{ display: "flex", gap: "10px", alignItems: "end", marginBottom: "20px" }}>
                    <StyledIcon src={data.iconUrl} alt="icon" />
                    <Typography gutterBottom variant="h5" component="div">
                        {data.name}
                    </Typography>
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreRounded />
                    </ExpandMore>
                </Box>
                {listTags}
            </CardContent>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    <ImageListComponent images={data.screenshotUrls} screenshotsClick={(index) => {
                        props.screenshotsClick(index)
                    }} />
                </CardContent>
            </Collapse>
            <CardContent>
                <Typography variant="body2" onClick={props.readMoreClick}>
                    {data.description}
                </Typography>
                <Box sx={{ width: "100%" }} textAlign="end">
                    <Chip label="View full description" onClick={props.readMoreClick} />
                </Box>
            </CardContent>
            <CardActions>
                <Icons>
                    {playStoreUrl}
                    {gitHubUrl}
                </Icons>

                {editView}
                {deleteView}

            </CardActions>
        </Card>
    )
}

const ImageListComponent = (props: { images: string[], screenshotsClick: (index: number) => void }) => {
    if (props.images.length <= maxScreenshots) {
        return (

            <ImageList cols={maxScreenshots}>
                {props.images.map((item, index) => (
                    <ImageListItem key={item}>
                        <img
                            src={item}
                            alt={item}
                            loading="lazy"
                            onClick={(e) => {
                                props.screenshotsClick(index)
                            }} />
                    </ImageListItem>
                ))}
            </ImageList>)
    } else {
        return (
            <ImageList cols={maxScreenshots} >
                {props.images.slice(0, maxScreenshots - 1).map((item, index) => (
                    <ImageListItem key={item}>
                        <img
                            src={item}
                            alt={item}
                            loading="lazy"
                            onClick={(e) => {
                                props.screenshotsClick(index)
                            }} />
                    </ImageListItem>
                ))}
                <ImageListItem key={"new"} sx={{ background: '#00000055' }}>
                    <div style={{ width: '100%', height: '100%' }} onClick={(e) => {
                        props.screenshotsClick(maxScreenshots - 1)
                    }}>
                        <div
                            style={{
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -50%)'
                            }}
                        >
                            More
                        </div>
                    </div>

                </ImageListItem>
            </ImageList>)
    }
}


export default ProjectCard
